import type { User } from '@/types/auth';
import { apiService } from './apiService';

export interface KycDataResponse {
  user: User;
  progress: number;
}

export const kycApi = {
  async getKycData(): Promise<KycDataResponse> {
    return apiService.get<KycDataResponse>('/kyc');
  },

  async updateKycData(updates: Partial<User>, sessionId: string): Promise<KycDataResponse> {
    return apiService.patch<Partial<User>, KycDataResponse>(`/kyc?sessionId=${sessionId}`, updates);
  },

  async getKycHistory(): Promise<unknown[]> {
    return apiService.get<unknown[]>('/kyc/history');
  },
};
